import { MAP_ACTIONS } from 'constants/actions';

export const establishmentOpen = establishmentId => ({
  establishmentId,
  type: MAP_ACTIONS.ESTABLISHMENT_OPEN,
});
